module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_VIII"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_vm._v("KEY TO PANELS")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('a', {
    attrs: {
      "id": "page_VIII"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This key to the panels helps locate the special and suggested exercises that occur throughout the volume. It should be noted that the panels are not exhaustive treatments of topics, and are meant to be read and used in their contexts.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-004"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_VIII"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("‘WHAT DO YOU THINK?’ PANELS")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_VIII"
    }
  }), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-001"
    }
  }, [_vm._v("Rewriting the story of human origins")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-003"
    }
  }, [_vm._v("The definition of myth")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-009"
    }
  }, [_vm._v("The Protevangelium")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hardening the heart")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ten Commandments in today’s society")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The jubilee today")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The structure of Numbers")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Why were later complaints treated more harshly?")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The biblical definition of murder")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#enc-053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reflecting on Noth’s themes")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Claims of Mosaic authorship")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Is Whybray right?")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-005"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("‘DIGGING DEEPER’ PANELS")]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-002"
    }
  }, [_vm._v("The Sumerian King List opening lines")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-004"
    }
  }, [_vm._v("Retelling modern cosmology theologically")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-005"
    }
  }, [_vm._v("Significant days in Genesis 1")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-006"
    }
  }, [_vm._v("Genesis and ecology")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-007"
    }
  }, [_vm._v("Adam and Cain: Deeds, words and character")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-008"
    }
  }, [_vm._v("The symbolism of Eve")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-010"
    }
  }, [_vm._v("Did Methuselah really live 969 years?")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-011"
    }
  }, [_vm._v("Find the palistrophe")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-012"
    }
  }, [_vm._v("Was there a universal flood?")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-013"
    }
  }, [_vm._v("Noah’s drunkenness: Does Genesis think it sinful?")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parallels between the patriarchs")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Are the patriarchal stories historical?")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Changing promises")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Akedah or sacrifice of Isaac")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ancient marriage customs")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judah’s speech")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The name of God")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Passover")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slavery and the "), _c('i', [_vm._v("lex talionis")])])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What did the cherubim look like?")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure of the laws")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making sense of sacrifice")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clean and unclean")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clarifying the order of ceremonies on the Day of Atonement")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ancient versions of the priestly blessing")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parallels in complaint stories")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The spies and the golden calf")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Archaeology and the tassels")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The bronze snake in the Timnah temple")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Balaam and his donkey")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Balaam outside the Bible")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_IX"
    }
  }), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Festivals and their importance")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New Testament’s appeal to Numbers")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ten Commandments and ancient treaties")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spin and the spies")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The love of God in Deuteronomy")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Use of Deuteronomy in Jewish worship")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The chosen place of worship in Deuteronomy")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deuteronomy’s humanitarianism")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("War in Deuteronomy")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#enc-054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Story and fulfilment of promises")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Source analysis of Genesis 1—11")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joseph and his brothers, Genesis 37")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#enc-059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Settings for the Pentateuch")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-006"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("OTHER PANELS")]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The religion of the patriarchs")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#enc-020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Egypt in the Joseph story")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further reflection on the census results")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 69
// module chunks = 0